/**
 * Where a product is offered for sale (t1227). `all` is the default and means
 * every customer-facing channel; the other two narrow it to one.
 *
 * `kiosk` covers everything physical and self-service — the kiosk tablet,
 * vending machines and cabinets. Staff-built orders are not a channel: staff
 * can sell anything regardless of this setting.
 */
export const PRODUCT_SALES_CHANNELS = ['all', 'web', 'kiosk'];
/** The channel a customer is shopping on. */
export const SALES_CHANNELS = ['web', 'kiosk'];
export function isSoldOn(productChannel, channel) {
    return productChannel === 'all' || productChannel === channel;
}
//# sourceMappingURL=sales-channels.js.map